/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// const productAgreementCheckboxes = document.querySelectorAll(".agree-for-conditions input");
const productVariantsDS = (productHandle, productHandleDiff) => {
  const masterSelect = document.querySelector(
    '.product-form__buy-buttons [name="id"]'
  );
  const optionsSet = document.querySelectorAll('[options-ds]');
  const options1 = optionsSet[0]
    ? optionsSet[0].querySelectorAll('[option-ds]')
    : [];
  const options2 = optionsSet[1]
    ? optionsSet[1].querySelectorAll('[option-ds]')
    : [];
  const options3 = optionsSet[2]
    ? optionsSet[2].querySelectorAll('[option-ds]')
    : [];

  //return sorted variants fot two products
  const getVariants = new Promise(async (resolve) => {
    const responseNormal = await fetch(
      `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandle}.js`
    );
    const responseDiff = await fetch(
      `${window.themeVariables.routes.rootUrlWithoutSlash}/products/${productHandleDiff}.js`
    );
    const resAsJsonNormal = await responseNormal.json();
    const resAsJsonDiff = await responseDiff.json();
    const variantsAvailNormal = resAsJsonNormal.variants.filter(
      (item) => item.available
    );
    const variantsAvailDiff = resAsJsonDiff.variants.filter(
      (item) => item.available
    );
    let variants = [...variantsAvailDiff, ...variantsAvailNormal];
    resolve(
      variants.sort((a, b) => {
        return a.price - b.price;
      })
    );
  });

  const setMasterVariantId = (id) => {
    masterSelect.value = id;
  };

  //TODO: after go back on page change variant (or just go on previous page)
  const setVariantUrl = (variant) => {
    const url = new URL(window.location),
          activeMetafieldTextArray = document.querySelectorAll('.variant-metafield__text.visible'),
          currentMetafieldTextArray = document.querySelectorAll(`.variant-metafield__text[data-variant-id="${variant}"]`);

    url.searchParams.set('variant', variant);
    window.history.replaceState({}, '', url.toString());

    activeMetafieldTextArray.forEach(text => {
      text.classList.remove('visible');
    });

    currentMetafieldTextArray.forEach(text => {
      text.classList.add('visible');
    });
  };

  //setting options combination on UI from variant options array
  const setOptions = (options) => {
    optionsSet.forEach((opt, i) => {
      opt.querySelectorAll('[option-ds]').forEach((item) => {
        item.removeAttribute('active');
        if (item.dataset.value === options[i]) {
          item.setAttribute('active', '');
          if (item.classList.contains('combo-box__option-item')) {
            let combobox = item.parentNode.parentNode;
            combobox._onValueClicked(null, (target = { value: options[i] }));
          }
          if (item.classList.contains('color-swatch')) {
            item.querySelector('input').checked = true;
          }
        }
      });
    });
  };

  const getOptions = () => {
    const combCur = [...options1, ...options2, ...options3]
      .filter((item) => item.hasAttribute('active'))
      .map((item) => item.dataset.value);
    return combCur;
  };

  const getVariantFromOpt = (variants, opt) => {
    let variant = variants.find((item) => {
      if (
        opt.includes(item.option1) &&
        opt.includes(item.option2) &&
        opt.includes(item.option3)
      ) {
        return item;
      }
    });
    !variant
      ? (variant = variants.find((item) => {
          if (opt.includes(item.option1) && opt.includes(item.option2)) {
            return item;
          }
        }))
      : null;
    !variant
      ? (variant = variants.find((item) => opt.includes(item.option1)))
      : null;
    return variant;
  };

  //disable options unavailable in curent options combination
  const clearOptions = (varComb, varCurData) => {
    let curentOpt2Avail = Object.keys(varComb[varCurData.option1]);
    let curentOpt3Avail = varComb[varCurData.option1][varCurData.option2];
    curentOpt2Avail.length
      ? options2.forEach((item) => {
          !curentOpt2Avail.includes(item.dataset.value)
            ? item.setAttribute('disabled', 'disabled')
            : item.removeAttribute('disabled', 'disabled');
        })
      : null;
    curentOpt3Avail.length
      ? options3.forEach((item) => {
          !curentOpt3Avail.includes(item.dataset.value)
            ? item.setAttribute('disabled', 'disabled')
            : item.removeAttribute('disabled', 'disabled');
        })
      : null;
  };

  const setJanadoThemeBlocks = (newVariant) => {
    document
      .querySelector('product-media')
      ._onVariantChanged({ detail: { variant: newVariant } });
    document
      .querySelector('product-meta')
      ._onVariantChanged({ detail: { variant: newVariant } });
    document.querySelector('product-meta')._updateLabels(newVariant);
    document
      .querySelector('product-payment-container')
      ._onVariantChanged({ detail: { variant: newVariant } });
    document
      .querySelector('product-inventory')
      ._onVariantChanged({ detail: { variant: newVariant } });

    // if (!newVariant.options.includes('Neu in OVP')) {
    //   document
    //     .querySelector('.product-comb .agree-for-conditions')
    //     .removeAttribute('hidden');
    //   document
    //     .querySelector('.product-comb .agree-for-conditions input')
    //     .removeAttribute('disabled');
    // } else {
    //   document
    //     .querySelector('.product-comb .agree-for-conditions')
    //     .setAttribute('hidden', '');
    //   document
    //     .querySelector('.product-comb .agree-for-conditions input')
    //     .setAttribute('disabled', 'disabled');
    // }

    document.querySelector('.product-form__option-value').innerHTML =
      newVariant.option1;
  };

  getVariants.then((variants) => {
    let urlVariant = Number(
      new URLSearchParams(window.location.search).get('variant')
    );
    let curentVariant = variants.find((item) => item.id === urlVariant)
      ? urlVariant
      : variants[0].id;
    let varCurData = variants.find((item) => item.id === curentVariant);

    //creation of all options combinations object
    let varComb = variants.reduce((acc, item) => {
      !acc[item.option1] ? (acc[item.option1] = {}) : null;
      acc[item.option1][item.option2]
        ? acc[item.option1][item.option2].push(item.option3)
        : (acc[item.option1][item.option2] = item.option3
            ? [item.option3]
            : []);
      return acc;
    }, {});

    setMasterVariantId(curentVariant);
    setOptions(varCurData.options);
    clearOptions(varComb, varCurData);

    const inIntervId = setInterval(() => {
      if (typeof hakuna !== 'undefined' && hakuna) {
        reInitHakuna(curentVariant);
        clearInterval(inIntervId)
      };
    }, 300);

    priceDifferenceCalc('.product-form--comboProduct');

    setJanadoThemeBlocks(varCurData);

    optionsSet.forEach((opt, i) => {
      opt.querySelectorAll('[option-ds]').forEach((item) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          let el = e.currentTarget;
          if (!el.hasAttribute('disabled') && !el.hasAttribute('active')) {
            let options = getOptions();
            options[i] = el.dataset.value;
            let newVariant = getVariantFromOpt(variants, [...options]);

            setVariantUrl(newVariant.id);
            setMasterVariantId(newVariant.id);
            setOptions(newVariant.options);
            clearOptions(varComb, newVariant);

            if (document.querySelector('#hakuna-details-widget')){
              reInitHakuna(newVariant.id);
            };

            priceDifferenceCalc('.product-form--comboProduct');

            setJanadoThemeBlocks(newVariant);
          }
        });
      });
    });
    firstHintLoad();
  });

  masterSelect.addEventListener('change', (e) => {
    let variantId = Number(e.target.value);
    setVariantUrl(variantId);
  });
};

document.addEventListener('variant:changed', (event) => {
  const agreeBlock = document.querySelector(
    '.product-deffault .agree-for-conditions'
  );
  const agreeInput = document.querySelector(
    '.product-deffault .agree-for-conditions input'
  );
  // if (!event.detail.variant.options.includes('Neu in OVP')) {
  //   agreeBlock.removeAttribute('hidden');
  //   agreeInput.removeAttribute('disabled');
  // } else {
  //   agreeBlock.setAttribute('hidden', '');
  //   agreeInput.setAttribute('disabled', 'disabled');
  // }
});

const productsVariantsSwitch = () => {
  let switchers = document.querySelectorAll('[name="switch-ds"]');
  switchers.forEach((item) => {
    item.addEventListener('change', (e) => {
      switchers.forEach((item) => {
        item.checked = e.target.checked;
      });
      setTimeout(() => {
        if (e.target.checked) {
          document.querySelector('.product-comb').setAttribute('hidden', '');
          document.querySelector('.product-normal').removeAttribute('hidden');
          if (document.querySelector('#hakuna-details-widget')) {
            reInitHakuna(document.querySelector('.product-normal .product-form input[name=id]').value);
          };
          document.querySelectorAll('.switch-ds__info').forEach((info) => {
            info.setAttribute('hidden', '');
          });
        } else {
          document.querySelector('.product-normal').setAttribute('hidden', '');
          document.querySelector('.product-comb').removeAttribute('hidden');
          if (document.querySelector('#hakuna-details-widget')) {
            reInitHakuna(document.querySelector('.product-comb .product-form input[name=id]').value);
          };
          document.querySelectorAll('.switch-ds__info').forEach((info) => {
            info.removeAttribute('hidden');
          });
        }
      }, 300);

      firstHintLoad();
    });
  });
};

//variants price difference calc
const priceDifferenceCalc = (productType) => {
  if (productType === '.product-form--comboProduct') {
    variantsJSON = comboVariantsJSON;
  }

  const productFormSingle = document.querySelector(productType);
  const optionSelectorsSingle = productFormSingle.querySelectorAll(
    '.product-form__option-selector'
  );

  function setPriceDiffSingleProduct() {
    let selectValue = [];
    const selectsArr = productFormSingle.querySelectorAll(
      '.product-form__option-selector select'
    );
    const colorSwatchList =
      productFormSingle.querySelector('.color-swatch-list');
    let startPrice;

    if (colorSwatchList) {
      selectValue.push(
        colorSwatchList.querySelector('.color-swatch__radio:checked').value
      );
    }

    selectsArr.forEach((option) => {
      if (option.selectedOptions) {
        selectValue.push(option.value);
      }
    });

    startPrice = variantsJSON[selectValue.join(' / ')];

    selectsArr.forEach((select) => {
      const optionsArr = select.querySelectorAll('option');
      const position = select.dataset.position;
      optionsArr.forEach((opt) => {
        let variant = [...selectValue];
        variant[position] = opt.value;
        variant = variant.join(' / ');

        let varianPrice;

        if (variantsJSON[variant]) {
          varianPrice = variantsJSON[variant];
        } else {
          Object.keys(variantsJSON).forEach((key) => {
            const keyArr = key.split(' / ');
            const variantArr = variant.split(' / ');
            const closeVariantPart = keyArr.reduce((acc, item, i) => {
              if (variantArr[i] === item) {
                i === keyArr.length - 1 ? null : acc.push(item);
              } else {
                i === keyArr.length - 1 ? null : acc.push('');
              }
              return acc[i - 1] === '' ? [] : acc;
            }, []);
            if (closeVariantPart.length) {
              const closeVariant = Object.keys(variantsJSON).find((item) =>
                item.includes(closeVariantPart.join(' / '))
              );
              varianPrice = variantsJSON[closeVariant];
            }
          });
        }

        const button = productFormSingle.querySelector(
          `button[data-value = '${opt.value}']`
        );
        const buttonPriceDiffWrapper = button.querySelector(
          '.priceDifference__wrapper'
        );
        let buttonPriceDiff = button.querySelector('.priceDifference__amount');
        let priceDiffAmount = (varianPrice - startPrice) / 100;

        if (priceDiffAmount) {
          buttonPriceDiffWrapper.classList.remove(
            'priceDifference__wrapper--hidden'
          );
          buttonPriceDiff.innerHTML =
            priceDiffAmount > 0
              ? `+${priceDiffAmount.toFixed(2)}`
              : priceDiffAmount.toFixed(2);
        } else {
          buttonPriceDiffWrapper.classList.add(
            'priceDifference__wrapper--hidden'
          );
        }
      });
    });
  }

  optionSelectorsSingle.forEach((selector) => {
    selector.addEventListener('change', () => {
      setPriceDiffSingleProduct();
    });
  });

  setPriceDiffSingleProduct();
};

// Product condition section
(() => {
  let select = document.querySelectorAll('.product-select'),
    block = document.querySelectorAll('.block-wrap'),
    buttonOpen = document.querySelectorAll('#condition'),
    conditionContent = document.querySelector('.product-condition__content'),
    backgroundCondition = document.querySelector('.product-condition__wrap'),
    buttonClose = document.querySelector('.conditional-close');

  select.forEach((element) => {
    element.addEventListener('change', changeDisplay);
  });

  if (buttonOpen) {
    buttonOpen.forEach((element) => {
      element.addEventListener('click', classToggle);
    });
    backgroundCondition
      ? backgroundCondition.addEventListener('click', classToggle)
      : null;
    buttonClose ? buttonClose.addEventListener('click', classToggle) : null;
  }

  function classToggle() {
    conditionContent.classList.toggle('hidden');
    backgroundCondition.classList.toggle('visible');
    setSelectedCondition();
  }

  function setSelectedCondition() {
    let conditionSelect = document.querySelector('[aria-label="Zustand"]'),
        currentOption = conditionContent.querySelector(`[value="${conditionSelect.value}"]`);

    if (currentOption) {
      currentOption.click();
    }
  }

  function changeDisplay(event) {
    block.forEach((element) => {
      if (element.dataset.option == event.currentTarget.value) {
        element.classList.remove('hidden');
      } else {
        element.classList.add('hidden');
      }
    });
  }
})();

const toggleQuickButButtons = (checkbox) => {
  const form = checkbox.closest("form"),
        shopifyQuickBuyButton = form.querySelector(".shopify-payment-button"),
        shopifyMorePaymentsLink = form.querySelector(".shopify-payment-button__more-options");

  if(shopifyQuickBuyButton) {
    if(checkbox.checked) {
      shopifyQuickBuyButton.classList.remove("hidden");
    } else {
      shopifyQuickBuyButton.classList.add("hidden");
    }
  }

  if(shopifyMorePaymentsLink) {
    if(checkbox.checked) {
      shopifyMorePaymentsLink.classList.remove("hidden");
    } else {
      shopifyMorePaymentsLink.classList.add("hidden");
    }
  }
}

//Set most afordable product variant
const setChipestVartiant = (url) => {
  pageUrl = new URL(window.location.href);
  if (
    !pageUrl.searchParams.get('variant') &&
    !document.querySelector('.product-form--comboProduct')
  ) {
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        let variants = data.variants
          .filter((item) => item.available)
          .sort((a, b) => {
            return a.price - b.price;
          });
        const productVariantEl = document.querySelector('product-variants');
        productVariantEl.selectVariant(variants[0].id);
      });
  }
};

// productAgreementCheckboxes.forEach(element => {
//   element.addEventListener("change", event => {
//     toggleQuickButButtons(event.currentTarget);
//   });

//   toggleQuickButButtons(element);
// });

// video in slideshow
const videoSlide = document.querySelectorAll('.slideshow__video');
const videoPlayBtn = document.querySelectorAll('.video__play-button');

videoPlayBtn.forEach(el => {
  el.addEventListener('click', () => {
    el.nextElementSibling.play();
    el.classList.add('hidden');
  });
});

videoSlide.forEach(elem => {
  elem.addEventListener('click', () => {
    const wrapper = elem.closest('.slideshow__image-wrapper');
    const playButton = wrapper.querySelector('.video__play-button');

    if (playButton) {
      elem.pause();
      playButton.classList.remove('hidden');
    }
  })
});
// Message with conditions

const messageConditions = document.querySelector('.product-form__messageConditions'); // string for input conditions
const conditionsArray = messageConditions.innerHTML.split(', ');
const messageArray = document.querySelectorAll('.product-form__message'); // info text
const selectButtons = document.querySelectorAll('.combo-box__option-item'); // selector options

selectButtons.forEach(el => {
  el.addEventListener('click', event => {
    messageArray.forEach(message => {
      message.classList.add('hidden');
    });
    conditionsArray.forEach(elem => {
      if (event.target.getAttribute('value') == elem) {
        messageArray.forEach(message => {
          message.classList.remove('hidden');
        });
      }
    });
  })
});

// for first load
function firstHintLoad() {
  messageArray.forEach(message => {
    message.classList.add('hidden');
  });

  const selectedValue = document.querySelectorAll('.product-form__variants .select__selected-value');
  selectedValue.forEach(element => {
    conditionsArray.forEach(elem => {
      if (element.innerHTML == elem) {
        const productForm = element.closest('.product');
        const messageArr = productForm.querySelectorAll('.product-form__message');

        if (!productForm.hasAttribute('hidden')) {
          messageArr.forEach(message => {
            message.classList.remove('hidden');
          });
        } else {
          messageArr.forEach(message => {
            message.classList.remove('hidden');
          });
        }
      }
    });
  });
}

function getProductInfo(id) {
  let foundProduct = null

  window.productInformation.forEach((array) => {
    if (array.variants) {
      array.variants.forEach((variant) => {
        if (variant.id == id) {
          foundProduct = array;

          return;
        };
      });
    }
  });

  return foundProduct;
};

function getVariantInfo(id) {
  let foundProduct = null

  window.productInformation.forEach((array) => {
    if (array.variants) {
      array.variants.forEach((variant) => {
        if (variant.id == id) {
          foundProduct = variant;

          return;
        };
      });
    }
  });

  return foundProduct;
};

function createHakunaObject(productObject, variantObject) {
 const hakunaObject = {
      brand: productObject.vendor,
      category: productObject.category,
      id: `${variantObject.id}`,
      price: {
          amount: variantObject.price,
          currency: Shopify.currency.active.toLowerCase()
      },
      quantity: 1,
      sku: `${productObject.id}-${variantObject.id}`,
      title: variantObject.name
  };

  return hakunaObject;
};

function reInitHakuna(id) {
  const productObject = getProductInfo(id);
  const variantObject = getVariantInfo(id);
  const hakunaObject = createHakunaObject(productObject, variantObject);
  const widgetArray = [];

  if (document.querySelector('#hakuna-details-widget')) {
    widgetArray.push('hakuna-details-widget');
  };

  if (document.querySelector('#hakuna-details-widget-2')) {
    widgetArray.push('hakuna-details-widget-2')
  };

  widgetArray.forEach((widget) => {
    hakuna.render({target: widget,  products: [hakunaObject], activePage: "details"})
  });
};

function setSecondHakunaWidgetId() {
  const hakunaWidgets = document.querySelectorAll('#hakuna-details-widget');

  if (hakunaWidgets.length > 1) {
    hakunaWidgets[1].setAttribute('id', 'hakuna-details-widget-2');
  };
};

setSecondHakunaWidgetId();

firstHintLoad();
